import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/business-and-finance-3.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_5 = { class: "modal-content container" }
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-1" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createVNode("h5", { class: "card-title text-center" }, "Quote Information")
], -1)
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    width: "100",
    class: "img-fluid",
    id: "animated_quote"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" You will get ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Quote Price ")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = { class: "row justify-content-center" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "col-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-10" }, null, -1)
const _hoisted_28 = { class: "col-1" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"success-checkmark\"><div class=\"check-icon\"><span class=\"icon-line line-tip\"></span><span class=\"icon-line line-long\"></span><div class=\"icon-circle\"></div><div class=\"icon-fix\"></div></div></div><br><h5 class=\"text-success\">ORDER EXECUTED!</h5><br>", 4)
const _hoisted_34 = { class: "bg-light rounded-left rounded-top container" }
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Side")
], -1)
const _hoisted_38 = { class: "col-6 text-right" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Amount")
], -1)
const _hoisted_41 = { class: "col-6 text-right" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Pair")
], -1)
const _hoisted_44 = { class: "col-6 text-right" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Executed price")
], -1)
const _hoisted_47 = { class: "col-6 text-right" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left" }, [
  /*#__PURE__*/_createVNode("h5", null, "Total")
], -1)
const _hoisted_50 = { class: "col-6 text-right" }
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-12 text-right" }
const _hoisted_54 = {
  key: 2,
  class: "modal-body"
}
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "col-1" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "col-10" }, null, -1)
const _hoisted_58 = { class: "col-1" }
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"error-banmark\"><div class=\"ban-icon\"><span class=\"icon-line line-long-invert\"></span><span class=\"icon-line line-long\"></span><div class=\"icon-circle\"></div><div class=\"icon-fix\"></div></div></div><br><h5 class=\"text-danger\">ORDER CANCELED!</h5>", 3)
const _hoisted_63 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("br", { class: "d-none d-md-inline-block d-lg-inline-block" }, null, -1)
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-12 col-sm-2 text-sm-left" }
const _hoisted_67 = {
  key: 0,
  class: "col-12 col-sm-10 text-sm-right container"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("svg", {
  class: "text-primary",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  width: "20",
  height: "20",
  viewBox: "0 2 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M21,18V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V6H12C10.89,6 10,6.9 10,8V16A2,2 0 0,0 12,18M12,16H22V8H12M16,13.5A1.5,1.5 0 0,1 14.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,12A1.5,1.5 0 0,1 16,13.5Z"
  })
], -1)
const _hoisted_69 = { class: "text-primary" }
const _hoisted_70 = { class: "font-weight-bold" }
const _hoisted_71 = {
  key: 1,
  class: "col-5 text-left small"
}
const _hoisted_72 = { class: "font-weight-bold text-primary" }
const _hoisted_73 = {
  key: 2,
  class: "col-7 text-right container small"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("span", { class: "text-small text-success" }, "Available to trade", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-12" }
const _hoisted_78 = { class: "input-group mb-3" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text font-weight-bold indicator-form" }, [
    /*#__PURE__*/_createTextVNode("Qu"),
    /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "o"),
    /*#__PURE__*/_createTextVNode("t"),
    /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "e")
  ])
], -1)
const _hoisted_80 = {
  key: 0,
  class: "form-control text-right"
}
const _hoisted_81 = { class: "input-group-append" }
const _hoisted_82 = { class: "input-group-text font-weight-bold" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-12" }
const _hoisted_85 = { class: "input-group mb-2" }
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text font-weight-bold indicator-form" }, [
    /*#__PURE__*/_createTextVNode(" Am"),
    /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "oun"),
    /*#__PURE__*/_createTextVNode("t ")
  ])
], -1)
const _hoisted_87 = { class: "input-group-append" }
const _hoisted_88 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Min. Amount ")
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-12" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-12" }
const _hoisted_95 = { class: "input-group mb-2" }
const _hoisted_96 = /*#__PURE__*/_createStaticVNode("<div class=\"input-group-prepend\"><div class=\"input-group-prepend\"><span class=\"input-group-text font-weight-bold indicator-form\">T<span class=\"d-none d-md-inline-block d-lg-inline-block\">o</span>t<span class=\"d-none d-md-inline-block d-lg-inline-block\">a</span>l</span></div></div>", 1)
const _hoisted_97 = { class: "input-group-append" }
const _hoisted_98 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" Min. Total ")
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-12  text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwoFactorAuthenticator = _resolveComponent("TwoFactorAuthenticator")
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")
  const _component_count_down = _resolveComponent("count-down")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_amountInput = _resolveComponent("amountInput")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_TwoFactorAuthenticator, {
      show: _ctx.modalShow,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalShow = false))
    }, null, 8, ["show"]),
    (_ctx.success)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "modal" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      (!_ctx.tradeSuccess && !_ctx.tradeError)
                        ? (_openBlock(), _createBlock("div", _hoisted_6, [
                            _createVNode("div", _hoisted_7, [
                              _hoisted_8,
                              _hoisted_9,
                              _createVNode("div", _hoisted_10, [
                                _createVNode("button", {
                                  type: "button",
                                  class: "close",
                                  "data-dismiss": "modal",
                                  "aria-label": "Close",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
                                }, [
                                  _hoisted_11
                                ])
                              ])
                            ]),
                            _hoisted_12,
                            _hoisted_13,
                            _createVNode("div", null, [
                              _createVNode("p", null, [
                                _hoisted_14,
                                (_ctx.type == 'BUY')
                                  ? (_openBlock(), _createBlock("span", _hoisted_15, [
                                      _createVNode("b", null, _toDisplayString(_ctx.formatZeros(_ctx.requestAmount, _ctx.amountPrecision)) + " " + _toDisplayString(_ctx.parity?.pair?.baseCurrencyId), 1),
                                      _hoisted_16,
                                      _createVNode("b", null, _toDisplayString(_ctx.isFiat(_ctx.parity?.pair?.quoteCurrencyId) ? '$': '') + _toDisplayString(_ctx.formatZeros(_ctx.requestFiatAmount, _ctx.totalPrecision)) + " " + _toDisplayString(_ctx.parity?.pair?.quoteCurrencyId), 1)
                                    ]))
                                  : (_openBlock(), _createBlock("span", _hoisted_17, [
                                      _createVNode("b", null, _toDisplayString(_ctx.isFiat(_ctx.parity?.pair?.quoteCurrencyId) ? '$': '') + _toDisplayString(_ctx.formatZeros(_ctx.requestFiatAmount, _ctx.totalPrecision)) + " " + _toDisplayString(_ctx.parity?.pair?.quoteCurrencyId), 1),
                                      _hoisted_18,
                                      _createVNode("b", null, _toDisplayString(_ctx.formatZeros(_ctx.requestAmount, _ctx.amountPrecision)) + " " + _toDisplayString(_ctx.parity?.pair?.baseCurrencyId), 1)
                                    ]))
                              ]),
                              _createVNode("p", null, [
                                _hoisted_19,
                                _createVNode("b", null, [
                                  _createTextVNode(_toDisplayString(_ctx.isFiat(_ctx.parity?.pair?.quoteCurrencyId) ? '$': ''), 1),
                                  _createVNode("b", null, _toDisplayString(_ctx.formatZeros(_ctx.requestPrice, _ctx.quotePrecision)), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.parity?.pair?.quoteCurrencyId), 1)
                                ]),
                                _createVNode(_component_CopyToClipboard, {
                                  text: _ctx.textForCopyToClipBoard()
                                }, null, 8, ["text"])
                              ])
                            ]),
                            _hoisted_20,
                            _createVNode(_component_count_down, {
                              initialTimerCount: 20,
                              initialrows: 2,
                              onUpdate: _cache[3] || (_cache[3] = ($event: any) => {
                                    $event != 0 ? _ctx.newRequestQuote() : _ctx.closeModal();
                                })
                            }),
                            _hoisted_21,
                            _createVNode("div", _hoisted_22, [
                              _createVNode("div", _hoisted_23, [
                                _createVNode("form", {
                                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.successQuote && _ctx.successQuote(...args)), ["stop","prevent"]))
                                }, [
                                  _createVNode("button", {
                                    "data-toggle": "modal",
                                    "data-target": "#trade",
                                    type: "submit",
                                    class: "btn btn-block btn-success",
                                    "data-dismiss": "modal",
                                    disabled: _ctx.blockButton
                                  }, "Convert", 8, ["disabled"])
                                ], 32)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.tradeSuccess)
                        ? (_openBlock(), _createBlock("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _hoisted_27,
                              _createVNode("div", _hoisted_28, [
                                _createVNode("button", {
                                  type: "button",
                                  class: "close",
                                  "data-dismiss": "modal",
                                  "aria-label": "Close",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModal()))
                                }, [
                                  _hoisted_29
                                ])
                              ])
                            ]),
                            _hoisted_30,
                            _createVNode("div", _hoisted_34, [
                              _hoisted_35,
                              _createVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _createVNode("div", _hoisted_38, _toDisplayString(_ctx.responseSuccess.side), 1)
                              ]),
                              _createVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.formatZeros(_ctx.responseSuccess.amount, _ctx.amountPrecision)+' '+_ctx.parity?.pair?.baseCurrencyId), 1)
                              ]),
                              _createVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode("div", _hoisted_44, _toDisplayString(_ctx.responseSuccess.instrument), 1)
                              ]),
                              _createVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createVNode("div", _hoisted_47, _toDisplayString(_ctx.formatZeros(_ctx.responseSuccess.executedPrice, _ctx.currentQuoteCurrency?.exact)+' '+_ctx.parity?.pair?.quoteCurrencyId), 1)
                              ]),
                              _createVNode("div", _hoisted_48, [
                                _hoisted_49,
                                _createVNode("div", _hoisted_50, _toDisplayString(_ctx.formatZeros(_ctx.responseSuccess.total, _ctx.totalPrecision)+' '+_ctx.parity?.pair?.quoteCurrencyId), 1)
                              ]),
                              _hoisted_51
                            ]),
                            _createVNode("div", _hoisted_52, [
                              _createVNode("div", _hoisted_53, [
                                _createVNode(_component_CopyToClipboard, {
                                  text: 
                                        'Side: '+_ctx.responseSuccess.side+'\n'+
                                        'Amount: '+_ctx.formatZeros(_ctx.responseSuccess.amount, _ctx.amountPrecision)+' '+_ctx.parity?.pair?.baseCurrencyId+'\n'+
                                        'Pair: '+_ctx.responseSuccess.instrument+'\n'+
                                        'Executed price: '+_ctx.formatZeros(_ctx.responseSuccess.executedPrice, _ctx.currentQuoteCurrency?.exact)+' '+_ctx.parity?.pair?.quoteCurrencyId+'\n'+
                                        'Total: '+_ctx.formatZeros(_ctx.responseSuccess.total, _ctx.totalPrecision)+' '+_ctx.parity?.pair?.quoteCurrencyId
                                        
                                }, null, 8, ["text"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.tradeError)
                        ? (_openBlock(), _createBlock("div", _hoisted_54, [
                            _createVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _hoisted_57,
                              _createVNode("div", _hoisted_58, [
                                _createVNode("button", {
                                  type: "button",
                                  class: "close",
                                  "data-dismiss": "modal",
                                  "aria-label": "Close",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal()))
                                }, [
                                  _hoisted_59
                                ])
                              ])
                            ]),
                            _hoisted_60,
                            _createVNode("p", null, _toDisplayString(!_ctx.error.response.data.message ? _ctx.error.response.data.errors.find((u) => u).message : _ctx.error.response.data.message), 1),
                            _hoisted_63
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_64,
    _createVNode("div", _hoisted_65, [
      _createVNode("div", _hoisted_66, [
        _createVNode("span", null, [
          _createVNode(_component_icons_currency, {
            pairType: !_ctx.isFiat(_ctx.parity?.pair?.quoteCurrencyId) ? 'crypto' : _ctx.isFiat(_ctx.parity?.pair?.baseCurrencyId) ? 'fiat' : null ,
            localCurrency: _ctx.parity?.pair?.quoteCurrencyId,
            cryptoCurrency: _ctx.parity?.pair?.baseCurrencyId,
            width: '20',
            height: '20',
            color: true,
            reverse: _ctx.type == 'BUY' ? false : true
          }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
        ])
      ]),
      (_ctx.status=='success')
        ? (_openBlock(), _createBlock("div", _hoisted_67, [
            _hoisted_68,
            _createTextVNode(_toDisplayString(_ctx.type == 'BUY' ? _ctx.fiatsAssets.find((currency) => currency.id == _ctx.parity?.pair?.quoteCurrencyId) ? '$' : '' : _ctx.fiatsAssets.find((currency) => currency.id == _ctx.parity?.pair?.baseCurrencyId) ? '$' : '') + " ", 1),
            _createVNode("span", _hoisted_69, _toDisplayString(_ctx.balance()), 1),
            _createVNode("span", _hoisted_70, " " + _toDisplayString(_ctx.type == 'BUY' ? _ctx.parity?.pair?.quoteCurrencyId : _ctx.parity?.pair?.baseCurrencyId), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.status=='success')
        ? (_openBlock(), _createBlock("div", _hoisted_71, [
            _createVNode("span", _hoisted_72, _toDisplayString(_ctx.cryptosAssets.find((currency) => currency.id == _ctx.parity?.pair?.baseCurrencyId)?.description), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.status=='success')
        ? (_openBlock(), _createBlock("div", _hoisted_73, [
            _hoisted_74
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_75,
    _createVNode("div", _hoisted_76, [
      _createVNode("div", _hoisted_77, [
        _createVNode("div", _hoisted_78, [
          _hoisted_79,
          (_ctx.tradeType == 'market')
            ? (_openBlock(), _createBlock("div", _hoisted_80, _toDisplayString(_ctx.type == 'BUY' ? _ctx.formatZeros((_ctx.price * _ctx.BUFFER), _ctx.quotePrecision) :_ctx.formatZeros((_ctx.price / _ctx.BUFFER), _ctx.quotePrecision)), 1))
            : _createCommentVNode("", true),
          (_ctx.tradeType == 'fok')
            ? _withDirectives((_openBlock(), _createBlock("input", {
                key: 1,
                type: "text",
                class: "form-control text-right",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.price = $event)),
                onKeypress: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updatePrice && _ctx.updatePrice(...args)))
              }, null, 544)), [
                [_vModelText, _ctx.price]
              ])
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_81, [
            _createVNode("span", _hoisted_82, _toDisplayString(_ctx.parity?.pair?.quoteCurrencyId), 1)
          ])
        ])
      ])
    ]),
    _createVNode("form", {
      onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestQuote && _ctx.requestQuote(...args)), ["stop","prevent"])),
      onKeypress: _cache[22] || (_cache[22] = (event)=>{
        if(event.key == 'Enter') {
            _ctx.requestQuote();
        }
    })
    }, [
      _createVNode("div", _hoisted_83, [
        _createVNode("div", _hoisted_84, [
          _createVNode("div", _hoisted_85, [
            _hoisted_86,
            _createVNode(_component_amountInput, {
              disabled: _ctx.pricesStatus !== 'success' || _ctx.price==0,
              "onUpdate:amount": _cache[9] || (_cache[9] = ($event: any) => (_ctx.amount = $event)),
              onFocus: _cache[10] || (_cache[10] = ()=>{
                        _ctx.focus = 'amount'
                    }),
              onClick: _cache[11] || (_cache[11] = ()=>{
                        _ctx.focus = 'amount'
                    }),
              onKeypress: _cache[12] || (_cache[12] = (event)=>{
                        _ctx.focus = 'amount'
                        _ctx.exchangeLevel()
                        _ctx.updatePrice()
                    }),
              amount: parseFloat(_ctx.amount),
              precision: _ctx.amountPrecision,
              select: _ctx.focus == 'amount'
            }, null, 8, ["disabled", "amount", "precision", "select"]),
            _createVNode("div", _hoisted_87, [
              _createVNode("span", {
                class: ["input-group-text font-weight-bold", {'text-primary': _ctx.type=='SELL' ? _ctx.focus == 'amount' || _ctx.focus == 'total_percent' : _ctx.focus == 'amount'}]
              }, _toDisplayString(_ctx.parity?.pair?.baseCurrencyId), 3)
            ])
          ]),
          (_ctx.amount < _ctx.parity?.pair?.minBase && _ctx.amount > 0)
            ? (_openBlock(), _createBlock("small", _hoisted_88, [
                _hoisted_89,
                _createVNode("b", null, _toDisplayString(_ctx.parity?.pair?.minBase), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_90, [
        _createVNode("div", _hoisted_91, [
          _createVNode("div", _hoisted_92, [
            _withDirectives(_createVNode("input", {
              disabled: _ctx.pricesStatus !== 'success' || _ctx.price==0,
              type: "range",
              min: 0,
              max: 100,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.totalPercent = $event)),
              class: "form-control-range",
              id: "formControlRange",
              onFocus: _cache[14] || (_cache[14] = ()=>{this.focus = 'total_percent'}),
              onInput: _cache[15] || (_cache[15] = ()=>{this.focus = 'total_percent'}),
              onClick: _cache[16] || (_cache[16] = ()=>{this.focus = 'total_percent'})
            }, null, 40, ["disabled"]), [
              [_vModelText, _ctx.totalPercent]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_93, [
        _createVNode("div", _hoisted_94, [
          _createVNode("div", _hoisted_95, [
            _hoisted_96,
            _createVNode(_component_amountInput, {
              disabled: _ctx.pricesStatus !== 'success' || _ctx.price==0,
              "onUpdate:amount": _cache[17] || (_cache[17] = ($event: any) => (_ctx.total = $event)),
              onFocus: _cache[18] || (_cache[18] = ()=>{
                        _ctx.focus = 'total'
                    }),
              onClick: _cache[19] || (_cache[19] = ()=>{
                        _ctx.focus = 'total'
                    }),
              onKeypress: _cache[20] || (_cache[20] = ()=>{
                        _ctx.focus = 'total'
                        _ctx.updatePrice()
                        _ctx.exchangeLevel()
                    }),
              amount: parseFloat(_ctx.total),
              precision: _ctx.totalPrecision,
              key: _ctx.keyQuoteInput,
              select: _ctx.focus == 'total'
            }, null, 8, ["disabled", "amount", "precision", "select"]),
            _createVNode("div", _hoisted_97, [
              _createVNode("span", {
                class: ["input-group-text font-weight-bold", {'text-primary': _ctx.type=='BUY' ? _ctx.focus == 'total'|| _ctx.focus =='total_percent' : _ctx.focus == 'total'}]
              }, _toDisplayString(_ctx.parity?.pair?.quoteCurrencyId), 3)
            ])
          ]),
          (_ctx.total < _ctx.parity?.pair?.minQuote && _ctx.total > 0)
            ? (_openBlock(), _createBlock("small", _hoisted_98, [
                _hoisted_99,
                _createVNode("b", null, _toDisplayString(_ctx.parity?.pair?.minQuote), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_100, [
        _createVNode("div", _hoisted_101, [
          _createVNode("button", {
            type: "submit",
            class: ["btn btn-success btn-lg btn-block", {'btn-danger': _ctx.type=='SELL'}],
            disabled: _ctx.blockButtonSubmit || _ctx.amount==0 ||_ctx.total == 0 || _ctx.price==0 || _ctx.amount < _ctx.parity?.pair?.minBase ||_ctx.total < _ctx.parity?.pair?.minQuote
          }, " Convert " + _toDisplayString(_ctx.type == "BUY" ? _ctx.parity?.pair?.quoteCurrencyId : _ctx.parity?.pair?.baseCurrencyId) + " to " + _toDisplayString(_ctx.type == "BUY" ? _ctx.parity?.pair?.baseCurrencyId : _ctx.parity?.pair?.quoteCurrencyId), 11, ["disabled"])
        ])
      ])
    ], 32)
  ], 64))
}